/** About window bridge (#350). Desktop Tauri only. */
import { listen, type UnlistenFn } from "@tauri-apps/api/event";
import { getCurrentWindow } from "@tauri-apps/api/window";
import { tauriOnlyInvoke } from "../invoke";

/** Event the menu sends to an open About window for "Check for Updates…". */
export const ABOUT_CHECK_UPDATES_EVENT = "about-check-updates";

/** Open (or focus) the native About window; `check` starts an update check. */
export async function openAboutWindow(check: boolean): Promise<void> {
  await tauriOnlyInvoke("open_about_window", { check });
}

/** True once when the About window was opened by "Check for Updates…". */
export async function takeAboutCheckRequest(): Promise<boolean> {
  return tauriOnlyInvoke<boolean>("take_about_check_request");
}

/** Run `handler` when the menu asks an open About window to check again. */
export async function listenAboutCheckUpdates(
  handler: () => void,
): Promise<UnlistenFn> {
  return listen(ABOUT_CHECK_UPDATES_EVENT, () => {
    handler();
  });
}

/** Close this About window (Escape). */
export async function closeAboutWindow(): Promise<void> {
  await getCurrentWindow().close();
}
